import { isArrayWithLength } from "../../utils/array-methods";
import {
  DEMO_PROJECT_USERS,
  DEMO_PROJECT_OWNERS,
} from "../helpers/project-constants.json";

export const allUsers = [
  {
    ID: 1,
    Type: "Human User",
    Name: "Cloud Admin",
    Email: "cloudadmin@montycloud.com",
    Roles: "Cloud Admin",
    CreatedDate: "Mon Aug 20 2018",
    ModifiedDate: "Mon Aug 20 2018",
    Status: "Active",
  },
  {
    ID: 2,
    Type: "Human User",
    Name: "Cassandra Hildebrandt",
    Email: "cassandra@montycloud.com",
    Roles: "Cloud Admin",
    CreatedDate: "Mon Aug 20 2018",
    ModifiedDate: "Mon Aug 20 2018",
    Status: "Active",
  },
  {
    ID: 3,
    Type: "Human User",
    Name: "John Foltz",
    Email: "dixie@montycloud.com",
    Roles: "Infrastructure, Operations Access",
    CreatedDate: "Mon Aug 20 2018",
    ModifiedDate: "Mon Aug 20 2018",
    Status: "Active",
  },
  {
    ID: 4,
    Type: "Human User",
    Name: "Venkat",
    Email: "venkat@montycloud.com",
    Roles: "Cloud Admin",
    CreatedDate: "Mon Aug 20 2018",
    ModifiedDate: "Mon Aug 20 2018",
    Status: "Active",
    Metadata: {
      CalendalyURL: "https://calendly.com/venkatkrish",
    },
  },
  {
    ID: 5,
    Type: "Human User",
    Name: "Project Owner",
    Email: "projectowner@montycloud.com",
    Roles: "Project Owner",
    CreatedDate: "Mon Aug 20 2018",
    ModifiedDate: "Mon Aug 20 2018",
    Status: "Active",
  },
  {
    ID: 6,
    Type: "Human User",
    Name: "Project User",
    Email: "projectuser@montycloud.com",
    Roles: "Project User",
    CreatedDate: "Mon Aug 20 2018",
    ModifiedDate: "Mon Aug 20 2018",
    Status: "Active",
  },
];

export const users = () => {
  return (
    isArrayWithLength(allUsers) &&
    allUsers.map((user) => {
      return {
        ...user,
        IdentityType: ["DAY2"],
        Roles: [
          {
            Dept: "319d813b-21d3-4f1a-911e-d2be7a662b07",
            Org: "140ab102-e22a-4499-b21b-8f84f4aad1f1",
            Role: DEMO_PROJECT_USERS.includes(user.Email)
              ? "d3de658f-e8ab-5596-85ba-f2646831026f"
              : DEMO_PROJECT_OWNERS.includes(user.Email)
              ? "8851ae0b-d16b-49a4-93e5-35fc38e87818"
              : "c71db059-6b93-4a95-9092-6d22d73a7fc6",
          },
        ],
        MFAConfigured: false,
      };
    })
  );
};

export const createUser = (data, users) => {
  let type, email, name;
  if (data.type === "human-user") {
    name = data.userName || data.Name;
    email = data.userEmail || data.Email;
  } else if (data.type === "ai-operator") {
    name = data.userCharacter[0].value;
    email = `${data.userCharacter[0].value}@montycloud.com`;
  } else if (data.device) {
    name = data.device[0].value;
    email = `${data.device[0].id}@montycloud.com`;
  } else {
    name = data.userName || data.Name || "Marvin";
    email = data.userEmail || data.Email || `marvin@montycloud.com`;
  }
  switch (data.type) {
    case "ai-operator":
      type = "DAY2™ Bot Operator";
      break;
    case "human-user":
      type = "Human User";
      break;
    case "chatbot":
      type = "Chatbot";
      break;
    default:
      type = "DAY2™ Bot Operator";
      break;
  }
  return {
    ID: users.length + 2,
    Type: type,
    Name: name,
    Email: email,
    Roles: data.Permissions,
    CreatedDate: "Mon Aug 20 2018",
    ModifiedDate: "Mon Aug 20 2018",
    Status: "Active",
    IdentityType: ["DAY2"],
  };
};

export const getPortalUsers = () => {
  return allUsers.map((user) => {
    return {
      ...user,
      DisplayName: user.Name,
      UserId: user.ID,
      Metadata: user.Metadata ? user.Metadata : null,
    };
  });
};
